import React from 'react';

const Loading = ({ message = "Loading...Please do not go back or close the window." }) => {
    return (
        <div className="loader-wrapper">
            <div className="loader"></div>
            <h3>{message}</h3>
        </div>
    );
};

export default Loading;
